// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__31tgo","label":"Labeled_label__1B8BA","divider":"Labeled_divider__3EkkN"};